
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sy",
      function () {
        return require("private-next-pages/sy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sy"])
      });
    }
  